import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as styleHelpersStyles } from '../../../assets/style-helpers.scss';
export const templateExclusionItemGrid = document.createElement('template');
templateExclusionItemGrid.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <style>${styleHelpersStyles}</style>
  <div class="wrapper">
      <div class="content">
            <div class="grid pt-4">
                <gz-grid-view class="grid-view" removeFilters hideGridRefresh disableGridSettings></gz-grid-view>
            </div>
      </div>
  </div>
`;
